export enum API_ENDPOINTS {
    postMessage = '(%s)/sendmessage',
    getImages = '(%s)/GetAttachments',
    helpDesk = '(%s)/askhelpdesk'
}
